/* eslint-disable no-useless-escape */
/* eslint-disable no-unused-vars */
/* Extensions */
import jQuery from 'jquery'
const $ = jQuery

import { MessageOverlay } from './message-overlay'

jQuery.fn.extend({
  showMe: function () {
    return this.removeClass('hidden')
  },

  hideMe: function () {
    return this.addClass('hidden')
  },

  toggleMe: function () {
    return this.toggleClass('hidden')
  },

  isHidden: function () {
    if (this.hasClass('hidden')) {
      return true
    } else {
      return false
    }
  },

  centerize: function () {
    return this.css({
      top: $(window).height() / 2 - this.height() / 2,
      left: $(window).width() / 2 - this.width() / 2,
    })
  },

  centerHorizontal: function () {
    return this.css({
      left: $(window).width() / 2 - this.width() / 2,
    })
  },

  setRandomID: function () {
    const random =
      'id-' +
      parseInt(Math.random() * 1000).toString() +
      new Date().getTime().toString()

    return this.attr({ id: random, name: random })
  },

  pulsate: function () {
    return this.animate({ opacity: 0 }, 250)
      .animate({ opacity: 1 }, 250)
      .animate({ opacity: 0 }, 250)
      .animate({ opacity: 1 }, 250)
  },

  selectText: function () {
    // http://stackoverflow.com/a/987376

    const element = this[0]
    let range
    let selection

    if (document.body.createTextRange) {
      // IE
      range = document.body.createTextRange()
      range.moveToElementText(element)
      range.select()
    } else if (window.getSelection) {
      // All others
      selection = window.getSelection()
      range = document.createRange()
      range.selectNodeContents(element)
      selection.removeAllRanges()
      selection.addRange(range)
    }
  },

  copyText: function () {
    // Select text based off input type
    $(this).is('input') ? $(this).select() : $(this).selectText()

    try {
      document.execCommand('copy')
      MessageOverlay.show('Copied to clipboard.', 'info', 3000)
    } catch (err) {
      MessageOverlay.show(
        'Could not copy to the clipboard. Please try again',
        'error'
      )
    }
  },

  replaceClass: function (remove, add) {
    return this.removeClass(remove).addClass(add)
  },

  resetFormInputs: function () {
    this.find('input[type=text]').val('')
    this.find('input[type=submit]').removeAttr('disabled')
  },

  toggleEmptyTable: function () {
    if (this.find('tbody tr').length === 0) {
      this.addClass('hidden')
    } else {
      this.removeClass('hidden')
    }
  },

  removeClassPrefix: function (prefix) {
    this.each(function (i, el) {
      const classes = el.className.split(' ').filter(function (c) {
        return c.lastIndexOf(prefix, 0) !== 0
      })
      el.className = classes.join(' ')
    })
    return this
  },

  classTransition: function (
    classname,
    showDuration = 1500,
    hideDuration = 250
  ) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const that = this
    const clone = that.clone()

    this.show().removeClass(classname)

    setTimeout(function () {
      that.addClass(classname)

      setTimeout(function () {
        that.hide()
        that.before(clone)
        that.remove()
      }, hideDuration)
    }, showDuration)

    return this
  },

  checkboxProps: function (check) {
    this.find('input[type="checkbox"]').prop('checked', check)
  },
})

/* Functions */
export function exists(selector) {
  return $(selector).length > 0
}

export function formatNumber(number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export function isValidEmail(email) {
  const regex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return !(!regex.test(email) || !email.length)
}

export function isValidDomain(domain) {
  const regex =
    /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]$/i
  domain = domain.replace('http://', '')
  return !(!regex.test(domain) || !domain.length)
}

export function pluralize(count, noun, suffix = 's') {
  return `${count} ${noun}${count !== 1 ? suffix : ''}`
}

export function isURL(value) {
  const domain = /^(?:\w+:)?\/\/(\S+)$/
  const path = /^[^\s\.]+\.\S{2,}$/

  if (typeof value !== 'string') {
    return false
  }

  const match = value.match(domain)
  if (!match) {
    return false
  }

  const afterDomain = match[1]
  if (!afterDomain) {
    return false
  }

  if (path.test(afterDomain)) {
    return true
  }

  return false
}
